import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import React, { useRef } from 'react'
import { Helmet } from 'react-helmet'
import BackgroundPage from 'src/components/BackgroundPage/BackgroundPage'
import BlankBackgroundPageContent from 'src/components/BlankBackgroundPageContent/BlankBackgroundPageContent'
import BreadcrumbsTopnav, {
  BreadcrumbPathComponent,
} from 'src/components/BreadcrumbsTopnav/BreadcrumbsTopnav'
import styled, { css } from 'styled-components'

export interface LayoutProps {
  children?: React.ReactElement
  title: string
  breadcrumbs?: BreadcrumbPathComponent[]
  actionComponent?: React.ReactElement
  detailsComponent?: React.ReactElement
  listComponent?: React.ReactElement
  breadCrumbsAnalytics?: string
  noBorder?: boolean
}

const SideBySideContentWrapper = styled.div`
  display: flex;
  gap: 48px;
  height: 100%;
  width: 100%;
  padding-top: 32px;

  ${getBreakpointDown(breakpointSizes.SM)(css`
    height: fit-content;
    flex-direction: column;
    gap: 20px;
  `)}
`

const ScrollableFixedContent = styled.div`
  overflow-y: auto;
  height: 100%;
  min-width: 400px;
  width: 400px;
  ${getBreakpointDown(breakpointSizes.SM)(css`
    width: 100%;
    height: auto;
    overflow: visible;
  `)}
`

const BorderDiv = styled.div`
  overflow: visible;
  width: 100%;
  border-radius: ${styleConstants.borderRadius.box};
  border: 1px solid ${styleConstants.colors.gray_medium};
  flex-shrink: 0;
  padding: 20px;
  max-height: fit-content;
`

const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  breadcrumbs,
  actionComponent,
  detailsComponent,
  listComponent,
  breadCrumbsAnalytics,
}) => {
  const breadcrumbsRef = useRef<HTMLDivElement>(null)
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={title} />
      </Helmet>
      <BackgroundPage
        backgroundColor={styleConstants.colors.white}
        fixedPageSize
      >
        {breadcrumbs && (
          <BreadcrumbsTopnav
            ref={breadcrumbsRef}
            breadcrumbs={breadcrumbs}
            actionsComponent={actionComponent}
            analytics={breadCrumbsAnalytics}
          />
        )}
        {children}
        <BlankBackgroundPageContent
          noStackingIndex
          css={css`
            overflow: hidden;
            ${getBreakpointDown(breakpointSizes.SM)(css`
              overflow: auto;
            `)}
          `}
        >
          <SideBySideContentWrapper>
            <ScrollableFixedContent>
              <BorderDiv>{detailsComponent}</BorderDiv>
            </ScrollableFixedContent>
            {listComponent}
          </SideBySideContentWrapper>
        </BlankBackgroundPageContent>
      </BackgroundPage>
    </>
  )
}

export default Layout
